td.changed {
  background-color: rgb(255, 255, 150);
}

.button {
  text-transform: none;
}
